import { humanizeFormula } from "@/features/esg/utils/formula-display";
import { CATEGORY_META } from "../schemas/custom-framework.schema";

export const CATEGORY_ORDER = CATEGORY_META.map((c) => c.key);

const IMPROVEMENT_DIRECTION_LABELS = {
  1: "1 — Higher is better",
  "-1": "-1 — Lower is better",
};

// Declarative table of optional metadata badges shown per disclosure — add a
// field here rather than another imperative `if (...) metaParts.push(...)`.
const META_FIELDS = [
  {
    key: "consol",
    when: (d) => d.isQuantitative && d.consolidationMethod,
    label: "Consolidation",
    value: (d) => d.consolidationMethod,
  },
  {
    key: "unit",
    when: (d) => d.inputType === "valueUnit" && d.defaultUnit,
    label: "Default Unit",
    value: (d) => d.defaultUnit,
  },
  {
    key: "direction",
    when: (d) => d.isQuantitative && d.improvementDirection != null,
    label: "Improvement Direction",
    value: (d) =>
      IMPROVEMENT_DIRECTION_LABELS[d.improvementDirection] ??
      d.improvementDirection,
  },
  {
    key: "carbon",
    when: (d) => d.isQuantitative && d.carbonEmissionMultiplier != null,
    label: "Carbon Emission Multiplier",
    value: (d) => d.carbonEmissionMultiplier,
  },
  {
    key: "calc",
    when: (d) => d.inputType === "calculated" && d.formula,
    label: "Calculated",
    value: (d) => humanizeFormula(d.formula, { baselineYear: d.baselineYear }),
  },
];

export const buildMetaParts = (d) =>
  META_FIELDS.filter((field) => field.when(d)).map((field) => ({
    key: field.key,
    label: field.label,
    value: field.value(d),
  }));

export function groupByCategory(disclosures) {
  const map = new Map();
  for (const d of disclosures) {
    const key = CATEGORY_ORDER.includes(d.category) ? d.category : "Other";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(d);
  }
  return [...CATEGORY_ORDER, "Other"]
    .filter((k) => map.has(k))
    .map((key) => ({ key, items: map.get(key) }));
}

export function groupByTopic(items) {
  const map = new Map();
  for (const d of items) {
    const key = d.topic?.trim() ? d.topic.trim() : "Ungrouped";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(d);
  }
  return [...map.entries()].map(([key, topicItems]) => ({
    key,
    items: topicItems,
  }));
}
